import { InteractionButton, ToolbarButtonGroup } from "../../lib/ui/toolbar/buttons";
export class SalesListSelectButton extends InteractionButton {
    constructor() {
        super('newspaper', 'Select parcels in Polygon (Sales List)', 'salesButton', 'Sales List', ToolbarButtonGroup.Group);
        this.set_interaction('sale');
    }
}
